import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vShow as _vShow, renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "form-check form-check-inline" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "true",
  class: "form-check-label"
}, "質問あり", -1)
const _hoisted_4 = { class: "form-check form-check-inline" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "false",
  class: "form-check-label"
}, "質問なし", -1)

import { computed, reactive, ref, unref, watch } from 'vue'
import { ConciergeSection } from '@/plugins/nicotto'
import { useValidateForm } from '@/components/ui/validator'
import FormGroup from '@/components/ui/FormGroup.vue'
import InputText from '@/components/ui/InputText.vue'
import InputTextArea from "@/components/ui/InputTextArea.vue";
import InputSkipSection from "@/components/ui/InputSkipSection.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ConciergeSection',
  props: {
    modelValue: null,
    categoryId: null,
    sectionId: { default: '' }
  },
  emits: ["update:modelValue", "submit"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'update:modelValue', section: ConciergeSection): void,
  (event: 'submit'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: ConciergeSection, categoryId: string, sectionId: string }



// eslint-disable-next-line func-call-spacing


const keys = ['sectionId', 'name', 'skip', 'question', 'supplement']
const section = reactive<any>({})
keys.forEach(key => {
  section[key] = computed({
    get() {
      return props.modelValue[key as keyof ConciergeSection]
    },
    set(val) {
      emit('update:modelValue', new ConciergeSection({ ...props.modelValue, [key]: val}))
    }
  })
})

const typeQuestion = ref('no')

const stop = watch(
  () => props.modelValue.question,
  (val) => {
    typeQuestion.value = (val !== '') ? 'yes' : 'no'
    stop()
  }
)

const form = ref<HTMLFormElement|null>(null)
const submit = () => {
  if (! useValidateForm(unref(form) as unknown as HTMLFormElement).isValid()) {
    return
  }
  if (typeQuestion.value !== 'yes') {
    emit('update:modelValue', new ConciergeSection({ ...props.modelValue, ['question']: ''}))
  }
  emit('submit')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(submit, ["prevent"]),
    ref_key: "form",
    ref: form,
    class: "formTable",
    novalidate: ""
  }, [
    _createVNode(FormGroup, {
      label: "種別",
      "label-for": "type",
      required: true
    }, {
      default: _withCtx(() => [
        _createVNode(InputText, {
          label: "種別",
          id: "type",
          modelValue: section.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((section.name) = $event)),
          required: true
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(FormGroup, {
      label: "質問タイプ",
      required: true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            id: "true",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((typeQuestion).value = $event)),
            name: "radioType",
            value: "yes",
            class: "form-check-input",
            required: ""
          }, null, 512), [
            [_vModelRadio, typeQuestion.value]
          ]),
          _hoisted_3
        ]),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            id: "false",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((typeQuestion).value = $event)),
            name: "radioType",
            value: "no",
            class: "form-check-input"
          }, null, 512), [
            [_vModelRadio, typeQuestion.value]
          ]),
          _hoisted_5
        ])
      ]),
      _: 1
    }),
    _withDirectives(_createVNode(FormGroup, {
      label: "質問",
      required: true
    }, {
      default: _withCtx(() => [
        _createVNode(InputTextArea, {
          label: "質問",
          modelValue: section.question,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((section.question) = $event)),
          required: typeQuestion.value === 'yes'
        }, null, 8, ["modelValue", "required"])
      ]),
      _: 1
    }, 512), [
      [_vShow, typeQuestion.value === 'yes']
    ]),
    _withDirectives(_createVNode(FormGroup, {
      label: "補足説明",
      "label-for": "description"
    }, {
      default: _withCtx(() => [
        _createVNode(InputTextArea, {
          label: "補足説明",
          modelValue: section.supplement,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((section.supplement) = $event)),
          id: "description"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 512), [
      [_vShow, typeQuestion.value === 'yes']
    ]),
    _withDirectives(_createVNode(FormGroup, { label: "回答後のスキップ先" }, {
      default: _withCtx(() => [
        _createVNode(InputSkipSection, {
          modelValue: section.skip,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((section.skip) = $event)),
          "category-id": __props.categoryId,
          "section-id": __props.sectionId
        }, null, 8, ["modelValue", "category-id", "section-id"])
      ]),
      _: 1
    }, 512), [
      [_vShow, typeQuestion.value === 'yes']
    ]),
    _renderSlot(_ctx.$slots, "default")
  ], 40, _hoisted_1))
}
}

})